import React from 'react'
import { useTranslation } from 'react-i18next'

import { BodyText, Card, Flex, Heading } from '../../../../App/Components'
import { CardImg } from '../../PerformanceOverview/style'

import { IProps } from './IProps'

export const PerformanceShoutOut = ({ personName, count, minutes }: IProps) => {
  const { t } = useTranslation()

  return (
    <Card
      backgroundGradient="linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)"
      cardHeight="100%"
      cardWidth="100%"
      fontColor="white"
      hoverSensitive
      style={{
        boxShadow: 'rgb(0 0 0 / 17%) 0px 41px 16px -27px',
        overflow: 'visible',
      }}>
      <Flex container style={{ position: 'relative' }}>
        <CardImg src={'/img/trophy-optios.png'} alt={'Congrats'} />
        <Heading level={'subSectionTitle'}>
          {t('{{name}} has been chosen the most', { name: personName })}
        </Heading>
        <BodyText headingLevel={'subSectionTitle'}>
          {t(
            'In total for {{count}} appointments good for {{hours}} hour and {{minutes}} minutes',
            {
              count,
              hours: Math.floor(minutes / 60),
              minutes: minutes % 60,
            },
          )}
        </BodyText>
      </Flex>
    </Card>
  )
}
